<template>
  <div class="dropzone">
    <!--UPLOAD-->
    <form enctype="multipart/form-data" novalidate>
      <h1>Choose Original file to Cast</h1>
          <p class="desktop-sign">
            <span v-if="dragDropSupported">Drag your file here to begin<br/> or click to browse</span>
            <span v-if="!dragDropSupported">Click to browse for file</span>
          </p>
          <p class="mobile-sign">
            <span v-if="dragDropSupported">Tap the screen to select a file</span>
            <span v-if="!dragDropSupported">Click to browse for file</span>
          </p>
      <div class="dropbox">
        <input type="file" :name="uploadFieldName"
                           @change="filesChange($event.target.name, $event.target.files)"
                           accept="audio/*|video/*|image/*|.mkv"
                           class="input-file dz">
      </div>
    </form>
  </div>
</template>

<script>
  import Vue               from 'vue'
  import { mapActions
         , mapGetters
         , mapState      } from 'vuex'

  export default {
    name: "Dropzone"
  , data () {
      return {
        fileCount: 0
      }
    }
  , computed: {
      ...mapState(['uploadFieldName', 'dragDropSupported'])
    }
  , methods: {
      ...mapActions(['performHashing'])
    , filesChange(fieldName, fileList) {
        // this.fileCount = fileList.length
        if (!fileList.length) return
        const file = fileList[0]
        this.performHashing({ fieldName, file })
        this.$router.push({ name: 'New' })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 95%;
    height: 100%;
    position: absolute;
    cursor: pointer;
  }

  .dz {
    width: 95%;
    margin-left: 5pt;
    margin-right: 5pt;
    left: 0;
  }

  // styles that change the sign on mobile
  .desktop-sign{
    display:inline-block;
}

  .mobile-sign{
    display:none;
}

@media screen and (max-width: 600px) {
    .desktop-sign{
       display:none;
    }

    .mobile-sign{
       display:inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/caster/Dropzone.vue